import Campaign from '../src/Campaign/index';
export default Campaign;
